import React from 'react'
import Magnetic from '../Components/Magnetic'
import { IconData } from './ContactInfo'

const Socials = () => {

  
   

  return (
    <div className="  flex flex-col justify-center h-[70vh] sm:gap-8 gap-12">
     
         <h1 className='text-[8vw] lg:text-5xl font-bold text-[#FFDC00] relative'>socials
      <span className='absolute -bottom-4 left-0 w-full h-0.5 bg-gradient-to-r from-[#FFDC00] to-transparent '></span>
      </h1>

      <div className='flex px-10 sm:px-0 flex-wrap gap-8  h-[40vh]   justify-center items-center'>
  {
    IconData.map((item, index) => {
    return (
      <Magnetic key={index} icon={item.icon} link={item.link}/>
    ) 
    })
  }
      </div>
     
      </div>
   
  )
}

export default Socials
